module.exports = __webpack_public_path__ + "static/sn-logo-c6dbbdb24674fa0410fa813d3e8fc5dc.svg";